import { Invoice } from '@models';
import { IInternationalInvoice } from '../../models/international-invoice';

export function canRemoveFromRegister(invoiceWithRegisterIndex: number, selected: Array<Invoice | IInternationalInvoice>): boolean {
  let isAllInOneRegister = false;
  if (invoiceWithRegisterIndex === 0) {
    const firstRegisterId = selected[invoiceWithRegisterIndex].ScanSheetRef;
    isAllInOneRegister = selected.every((i: Invoice | IInternationalInvoice) => i.ScanSheetRef === firstRegisterId);
  }

  return isAllInOneRegister;
}

export function checkAlreadyInRegister(invoiceWithRegisterIndex: number): boolean {
  return invoiceWithRegisterIndex > -1;
}
export function checkSameSenders<T>(
  head: T,
  tail: T[],
  comparator: (a: T, b: T) => boolean
): boolean {
  return tail.every(item => comparator(head, item));
}